<template>
  <div class="relative w-full mt-12">
    <div
      class="flex flex-col flex-wrap min-w-0 break-words shadow-lg rounded-md bg-white"
    >
      <div class="flex justify-center">
        <CategoryCreatePage
          v-if="operationMode === 'create'"
          :categoryName="$route.params.categoryName"
        />
        <CategoryUpdatePage
          v-if="operationMode === 'edit'"
          :categoryName="$route.params.categoryName"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import CategoryCreatePage from "@/components/ComponentModule/CategoryComponent/CategoryCreatePage";
import CategoryUpdatePage from "@/components/ComponentModule/CategoryComponent/CategoryUpdatePage";

export default {
  name: "CategoryPage",
  components: { CategoryCreatePage, CategoryUpdatePage },
  created() {
    // check tamper monkey region parameter
    if (this.$route.query.region) {
      this.$store.dispatch(Actions.SET_REGION, this.$route.query.region);
    }
  },
  mounted() {
    if (
      this.$router.currentRoute.value.fullPath.split("/").includes("edit") &&
      this.operationMode !== "edit"
    ) {
      // if url has 'edit' keyword, set operation to edit
      this.$store.dispatch(Actions.CHANGE_CATEGORY_OPERATION, "edit");
    } else if (
      this.$router.currentRoute.value.fullPath.split("/").includes("create") &&
      this.operationMode !== "create"
    ) {
      // if url has 'create' keyword, set operation to create
      this.$store.dispatch(Actions.CHANGE_CATEGORY_OPERATION, "create");
    }
  },
  computed: {
    ...mapGetters(["operationMode"])
  }
};
</script>
